import { FollowFormValues, FollowFormFileItem, OnsiteCustomer } from '../components/FollowFormModal';
import { AlertSettings } from '../components/NotifRecipientModal';
import { isoUtcToJstDate } from './dateUtils';

/**
 * followAPI.selectFollow レスポンスを FollowFormValues と関連データに変換する。
 * BCD の編集ハンドラ・将来の再利用箇所で共通使用。
 */
export function convertFollowResponseToFormValues(follow: any): {
  formValues: Partial<FollowFormValues>;
  attendeesList: OnsiteCustomer[];
  attachList: FollowFormFileItem[];
} {
  const formattedDate = isoUtcToJstDate(follow.followdate || '');

  // 同席者（客先）
  const attendeesList: OnsiteCustomer[] = (follow.attendees || []).map((a: any) => ({
    customerno: a.customerno,
    customername: a.customername || '',
    companyname: a.companyname || '',
    deptname: a.deptname || '',
  }));

  // 社内同席者
  let internalAttendees: number[] = [];
  try {
    internalAttendees = JSON.parse(follow.ourattendeesno || '[]');
  } catch {
    internalAttendees = [];
  }

  // 添付ファイル
  const attachList: FollowFormFileItem[] = (follow.attachfile || []).map((f: any) => ({
    uid: String(f.attachfileno),
    name: f.attachfilename || f.name || '',
    size: parseFloat(f.attachfilesize || '0') * 1024,
    attachfileno: f.attachfileno,
  }));

  // 拡張フィールド
  let optionFieldVals: Record<string, any> = {};
  if (follow.optionfield) {
    try { optionFieldVals = JSON.parse(follow.optionfield); } catch {}
  }

  // 訪問時刻
  const schedH = follow.outgovisitschedultimehour || '';
  const schedM = follow.outgovisitschedultimemin || '';
  const startH = follow.outgovisitstarttimehour || '';
  const startM = follow.outgovisitstarttimemin || '';
  const endH = follow.outgovisitendtimehour || '';
  const endM = follow.outgovisitendtimemin || '';

  return {
    formValues: {
      date: formattedDate,
      assigneeUserno: follow.contactuserno ?? null,
      content: follow.followcontent || '',
      isProvisional: follow.temporaryflag || false,
      isTodo: !!follow.plantodoflag,
      fileList: attachList,
      isOnsite: follow.outgovisitflag || false,
      followScheduledTime: schedH && schedM ? `${schedH}:${schedM}` : '',
      followAppointment: follow.outgovisitappoint || '',
      followVisitPurpose: follow.outgovisitpurpose || '',
      followStartTime: startH && startM ? `${startH}:${startM}` : '',
      followEndTime: endH && endM ? `${endH}:${endM}` : '',
      onsiteCustomers: attendeesList,
      selectedInternalAttendees: internalAttendees,
      optionFieldValues: optionFieldVals,
    },
    attendeesList,
    attachList,
  };
}

/**
 * follow APIレスポンスから AlertSettings を構築する。
 * plantodoflag が falsy、またはアラートフィールドが未設定の場合は undefined を返す。
 * realertflag=false は「明示的に再アラートOFF」として区別するため != null でチェックする。
 */
export function buildAlertSettingsFromFollow(follow: {
  plantodoflag?: any;
  prealert?: string | null;
  realert?: string | null;
  realertflag?: boolean | null;
}): Partial<AlertSettings> | undefined {
  if (!follow.plantodoflag) return undefined;
  if (!follow.prealert && !follow.realert && !follow.realertflag) return undefined;
  return {
    preAlert: follow.prealert ? String(follow.prealert) : '',
    reAlert: follow.realert ? String(follow.realert) : '',
    reAlertFlag: !!follow.realertflag,
  };
}
